import { render, staticRenderFns } from "./MenuCmd.vue?vue&type=template&id=9821a49e&scoped=true&"
import script from "./MenuCmd.vue?vue&type=script&lang=js&"
export * from "./MenuCmd.vue?vue&type=script&lang=js&"
import style0 from "./MenuCmd.vue?vue&type=style&index=0&id=9821a49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9821a49e",
  null
  
)

export default component.exports